import css from 'styled-jsx/css';
import getColor, { COLOR_DICTIONARY } from "@gc-npm/utils.enums.colors";


export default css`
   :global(hr) {
      margin: 0.7rem 0 0.7rem 0;
      border-top-width: 2px;
      color: ${getColor(COLOR_DICTIONARY.GREY_200)};
    }
  :global(.filterTitle) {
    padding-right:10px;
    padding-left:6px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 42px;
    width: 100%;
    margin-bottom: 6px;
  }
  :global(.filterTitle:hover) {
    background: ${getColor(COLOR_DICTIONARY.GREY_100)};
    border-radius: 5px;
  }
  :global(button.filterTitle:focus-visible) {
    outline: 2px solid ${getColor(COLOR_DICTIONARY.BLUE_HIGH)};
    outline-offset: 2px;
  }
  :global(.filtersContent[hidden]) {
    display: none;
  }

  :global(.filtersContent) {
    max-height: 0;
    height:0;
    overflow: hidden;
    transition: max-height 0.4s ease-in;
  }

  :global(.opened.filtersContent ) { 
    display:block;
  }
  :global(.opened) {
    height: auto;
    max-height: fit-content;
    transition: max-height 0.3s ease-out;  
  }

  :global(.chevronFilter) {
    display: block;
    width: max-content;
    transition: transform 0.2s ease;
    height:20px;
  }

  :global(.chevronFilterOpen) {
    transform: rotate(180deg);
    transition: transform 0.2s ease;
    height:20px;
  }
  @media (max-width: 1067px) and (min-width: 568px) {
    :global(.filterContainer) {
      width: 28%;
      margin-left: 3%;
      margin-rigth: 3%;
      float: left;
      padding-right: 10px;
    }

    :global(.filterTitle) {
      margin-top: 35px;
    }
  }
`;
